import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RenderColorTable(component, index) {
    return _jsx(ColorTable, {});
}
function ColorTable() {
    function getColorName(role, accent, contrast = false) {
        let result = `--color-${role}`;
        if (accent !== 'default') {
            result += `-${accent}`;
        }
        if (contrast) {
            result += `-contrast`;
        }
        return result;
    }
    function getColor(role, accent) {
        return (_jsx("div", { style: {
                minWidth: '6em',
                minHeight: '2em',
                backgroundColor: `var(${getColorName(role, accent)})`,
                margin: '0.5em',
            }, children: _jsx("span", { style: { color: `var(${getColorName(role, accent, true)})` }, children: "Text" }) }));
    }
    function getColorRow(role) {
        return (_jsxs("tr", { children: [_jsx("th", { children: role }), _jsx("td", { children: getColor(role, 'default') }), _jsx("td", { children: getColor(role, 'accent1') }), _jsx("td", { children: getColor(role, 'accent2') }), _jsx("td", { children: getColor(role, 'faded1') }), _jsx("td", { children: getColor(role, 'faded2') })] }));
    }
    function emptyRow() {
        return (_jsx("tr", { style: { height: '1em' }, children: _jsx("td", { colSpan: 6, children: "\u00A0" }) }));
    }
    return (_jsxs("table", { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "Default" }), _jsx("th", { children: "Accent 1" }), _jsx("th", { children: "Accent 2" }), _jsx("th", { children: "Faded 1" }), _jsx("th", { children: "Faded 2" })] }) }), _jsxs("tbody", { children: [getColorRow('default'), emptyRow(), getColorRow('primary'), getColorRow('secondary'), getColorRow('tertiary'), emptyRow(), getColorRow('success'), getColorRow('info'), getColorRow('warning'), getColorRow('error'), getColorRow('disabled'), emptyRow(), getColorRow('waiting'), getColorRow('inprogress'), getColorRow('completed'), getColorRow('canceled')] })] }));
}
